<template>
  <div
    class="application-composition-cylinder text-center"
    :class="{ 'is-selected': selected }"
  >
    <section>
      <div class="graph-cylinder">
        <ul class="graph">
          <li
            class="item"
            :class="themeMap[index]"
            :data-amount="getPercentage"
          >
            <span class="txt">
              {{compositionName}}
              <br>
              ({{volumeByWeightUnit(total)}} {{getWeightUnit}})
            </span>
          </li>
        </ul>
      </div>
    </section>
    <!-- <svg
      viewBox="0 0 100 200"
      width="100px"
      height="200px"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
    >
      <defs>
        <clipPath :id="`my-clip-${id}`">
          <rect
            x="0"
            :y="getCylinderFillPosition"
            width="100"
            height="200"
          ></rect>
        </clipPath>
      </defs>
      <svg
        width="95px"
        height="199px"
        viewBox="0 0 95 199"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g :id="`Page-${id}`" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g :id="`Group-${id}`">
            <path
              :clip-path="`url(#my-clip-${id})`"
              d="M88.4836821,190.499795 L88.4836821,99.5054936 C88.6871235,88.7274354 87.0534022,77.5834679 83.5825183,66.0735912 C79.6402258,55.2609639 72.8945955,43.5420888 63.3456276,30.9169661 L63.3456276,21.5 L32.2489571,21.5 L32.2489571,30.9169661 C21.976324,45.2308802 15.1676297,56.9497552 11.822874,66.0735912 C8.47811833,78.0450941 6.70401979,89.1890616 6.50057839,99.5054936 L6.49999501,190.5 C6.49998814,191.604569 7.39541307,192.500006 8.49998257,192.500012 C8.49998838,192.500012 8.49999419,192.500012 8.5,192.500012 L86.4836821,192.499795 C87.5882496,192.499793 88.4836771,191.604363 88.4836771,190.499795 Z"
              :id="`Path-${id}-Copy`"
              fill="#80CF19"
            ></path>
            <g :id="`Appinder-${id}-copy`" fill="#0074C0" fill-rule="nonzero">
              <path
                d="M23,4 L23,15 L73,15 L73,4 L23,4 Z M23,0 L73,0 C75.209139,-4.05812251e-16 77,1.790861 77,4 L77,15 C77,17.209139 75.209139,19 73,19 L23,19 C20.790861,19 19,17.209139 19,15 L19,4 C19,1.790861 20.790861,4.05812251e-16 23,0 Z"
                :id="`Rectangle-Copy-${id}`"
              ></path>
              <path
                d="M48.1886491,195 L89,195 C90.1045695,195 91,194.104569 91,193 L91,98.392386 C91,85.8431119 89.0257548,74.1859619 85.0809803,63.4106654 C82.4756395,56.2940814 79.6028117,50.6357668 75.8114186,44.6684077 C75.0427415,43.4585694 74.2397129,42.23823 73.2656003,40.7911255 C72.7235923,39.9859393 70.8885944,37.2856277 70.7221683,37.0396533 C68.72561,34.0887819 67.3966686,32.0330489 66.0914111,29.8174266 L65.8146163,29.3475785 L65.8146163,19 L48.8960706,19 L29.1853837,19 L29.1853837,29.3475785 L28.9085889,29.8174266 C27.6033314,32.0330489 26.27439,34.0887819 24.2778317,37.0396533 C24.1114056,37.2856277 22.2764077,39.9859393 21.7343997,40.7911255 C20.7602871,42.23823 19.9572585,43.4585694 19.1885814,44.6684077 C15.3971883,50.6357668 12.5243605,56.2940814 9.91901973,63.4106654 C5.97424521,74.1859619 4,85.8431119 4,98.392386 L4,193 C4,194.104569 4.8954305,195 6,195 L48.1886491,195 Z M48.1886491,199 L6,199 C2.6862915,199 -1.40598644e-12,196.313708 -1.54187774e-12,193 L1.62092562e-12,98.392386 C1.62092562e-12,85.3839432 2.05303472,73.2615717 6.16282005,62.0355422 C8.87255736,54.6337952 11.874263,48.7216432 15.8123943,42.5233294 C16.6023095,41.280064 17.4238523,40.0315891 18.416155,38.5574622 C18.9640617,37.7435131 20.8028977,35.0375534 20.9648964,34.7981227 C22.7753962,32.122242 24.0151944,30.2135552 25.1853837,28.2537925 L25.1853837,15 L48.8960706,15 L69.8146163,15 L69.8146163,28.2537925 C70.9848056,30.2135552 72.2246038,32.122242 74.0351036,34.7981227 C74.1971023,35.0375534 76.0359383,37.7435131 76.583845,38.5574622 C77.5761477,40.0315891 78.3976905,41.280064 79.1876057,42.5233294 C83.125737,48.7216432 86.1274426,54.6337952 88.8371799,62.0355422 C92.9469653,73.2615717 95,85.3839432 95,98.392386 L95,193 C95,196.313708 92.3137085,199 89,199 L48.1886491,199 Z"
                :id="`Combined-Shape-${id}`"
              ></path>
            </g>
          </g>
        </g>
      </svg>
    </svg>
    <div class="application-composition-cylinder-item-percentage text-center font-weight-bold">
      <p class="mb-0">{{getPercentage}}%</p>
    </div>
    <p
      class="text-center mb-0"
    >{{compositionName}}</p>
    <p>({{volumeByWeightUnit(total)}} {{getWeightUnit}})</p> -->
    <!-- <p><button class="btn btn-danger btn-sm" @click="$emit('deleteComposition', { id: parseInt(id) })">Delete Composition</button></p> -->
  </div>
</template>

<script>
  export default {
    props: {
      id: {
        type: [Number, String],
        required: true
      },
      index: {
        type: Number,
        default: -1,
      },
      compositionName: {
        type: String,
        default: '',
      },
      total: {
        type: Number,
        default: 0
      },
      subtracted: {
        type: Number,
        required: true
      },
      selected: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        themeMap: {
          0: 'item-blue',
          1: 'item-red',
          2: 'item-orange',
          3: 'item-green ',
          4: 'item-violet',
          5: 'item-cyan',
          6: 'item-pink',
        }
      };
    },


    computed: {
      getWeightUnit() {
        return this.$store.getters['user/getWeightUnit'];
      },
      getPercentage() {
        let subtractedTotal = this.total - this.subtracted;
        if (subtractedTotal < 0) {
          subtractedTotal = 0;
        }

        return this.calculatePercentage(subtractedTotal, this.total);
      },
      getCylinderFillPosition() {
        const percent = 100 - this.getPercentage;
        return ((percent / 100) * 195).toFixed(0);
      }
    },

    methods: {
      calculatePercentage(obtained, total) {
        if (obtained === 0 || total === 0) {
          return 0;
        }

        return ((obtained * 100) / total).toFixed(0);
      },
      volumeByWeightUnit(volume) {
        if (this.getWeightUnit === 'ton') {
          return volume / 1000;
        }
        return volume;
      },
    },
  };
</script>

<style lang="scss">

  .application-composition-cylinder {
    position: relative;
    opacity: 0.9;
    transition: all 0.3s;
    p {
      color: #7fcf1a;
      transition: all 0.3s;
    }

    &.is-selected {
      opacity: 1;
      p {
        color: #0073c0;
        font-weight: 600;
      }
    }
  }
  .application-composition-cylinder-item-percentage {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    height: 16px;
    margin: auto;
    font-size: 26px;
  }


.head-title {
	width: 100%;
	background-color: #333;
	color: #aaa;
	text-align: center;
	margin: 0;
	padding: 10px;
}
body > section {
	width: 100%;
	padding: 20px;
	box-sizing: border-box;
	display: flex;
	flex-flow: row nowrap;
	justify-content: center;
	align-items: center;
}
/* -----------------------------
// graph-cylinder
----------------------------- */

.graph-cylinder .graph {
	height: 200px;
	width: 100%;
  max-width: 70px;
	padding: 0;
	margin: 0 auto;
	font-size: 0;
	display: flex;
	flex-flow: row nowrap;
	align-items: flex-end;
}
.graph-cylinder .graph > .item {
	display: flex;
	font-size: 12px;
	position: relative;
	flex: 1;
	text-align: center;
	flex-flow: column nowrap;
	justify-content: flex-end;
	box-sizing: border-box;
	line-height: 1;
	width: 70px;
	border-radius: 70px/35px;
	z-index: 1;
	box-shadow: 10px 12px 18px 18px rgba(0, 0, 0, .3) inset;
}
.graph-cylinder .graph > .item > .txt {
	position: relative;
	top: 30px;
}
.graph-cylinder .graph > .item + .item {
	margin-left: 8px;
}
.graph-cylinder .graph > .item:before {
	content: "";
	display: block;
	position: absolute;
	bottom: 0;
	width: 70px;
	height: 35px;
	background-color: rgba(75, 75, 75, .2);
	border-radius: 70px/35px;
	z-index: -1;
	box-shadow: -5px 2px 4px 2px rgba(0, 0, 0, .1) inset;
}
.graph-cylinder .graph > .item:after {
	content: attr(data-amount) "%";
	display: block;
	position: absolute;
	top: 0;
	width: 70px;
	height: 35px;
  font-size: 18px;
	background-color: rgba(230, 230, 230, .1);
	border-radius: 70px/35px;
	z-index: 2;
	box-shadow: 5px -2px 4px 2px rgba(255, 255, 255, .1) inset;
	text-shadow: 0 0 1px #fff, 0 0 1px #fff, 0 0 1px #fff, 0 0 1px #fff, 0 0 1px #fff;
}


.graph-cylinder .graph-head {
	background-color: #ccc;
	margin: 0;
	border-bottom: 1px solid #fff;
	text-align: center;
	font-size: 16px;
	padding: 3px;
	line-height: 1;
	margin-bottom: 20px;
}

.graph-cylinder .graph > .item-blue {
	background-image: linear-gradient(
		90deg,
		rgba(111, 147, 218, .8),
		rgba(50, 101, 203, .8) 50%,
		rgba(43, 86, 173, .8)
	), linear-gradient(
		0deg,
		rgba(24, 24, 24, .65),
		rgba(112, 112, 112,.65)
	);

}
.graph-cylinder .graph > .item-red {
	background-image: linear-gradient(
		90deg,
		rgba(230, 115, 88, .8),
		rgba(220, 56, 17, .8) 50%,
		rgba(187, 48, 14, .8)
	), linear-gradient(
		0deg,
		rgba(24, 24, 24, .65),
		rgba(112, 112, 112,.65)
	);
}
.graph-cylinder .graph > .item-orange {
	background-image: linear-gradient(
		90deg,
		rgba(255, 182, 76, .8),
		rgba(255, 152, 0, .8) 50%,
		rgba(217, 129, 0, .8)
	), linear-gradient(
		0deg,
		rgba(24, 24, 24, .65),
		rgba(112, 112, 112,.65)
	);
}
.graph-cylinder .graph > .item-green {
	background-image: linear-gradient(
		90deg,
		rgba(87, 181, 93, .8),
		rgba(16, 150, 24, .8) 50%,
		rgba(14, 128, 20, .8)
	), linear-gradient(
		0deg,
		rgba(24, 24, 24, .65),
		rgba(112, 112, 112,.65)
	);
}
.graph-cylinder .graph > .item-violet {
	background-image: linear-gradient(
		90deg,
		rgba(183, 76, 183, .8),
		rgba(152, 0, 152, .8) 50%,
		rgba(129, 0, 128, .8)
	), linear-gradient(
		0deg,
		rgba(24, 24, 24, .65),
		rgba(112, 112, 112,.65)
	);
}
.graph-cylinder .graph > .item-cyan {
	background-image: linear-gradient(
		90deg,
		rgba(76, 182, 215, .8),
		rgba(0, 152, 198, .8) 50%,
		rgba(0, 129, 168, .8)
	), linear-gradient(
		0deg,
		rgba(24, 24, 24, .65),
		rgba(112, 112, 112,.65)
	);
}
.graph-cylinder .graph > .item-pink {
	background-image: linear-gradient(
		90deg,
		rgba(232, 62, 140, .8),
		rgba(233, 82, 151, .8) 50%,
		rgba(232, 49, 133, .8)
	), linear-gradient(
		0deg,
		rgba(24, 24, 24, .65),
		rgba(112, 112, 112,.65)
	);
}


.graph-cylinder [data-amount="0"] {height: 18%;}
.graph-cylinder [data-amount="1"] {height: 18.82%;}
.graph-cylinder [data-amount="2"] {height: 19.64%;}
.graph-cylinder [data-amount="3"] {height: 20.46%;}
.graph-cylinder [data-amount="4"] {height: 21.28%;}
.graph-cylinder [data-amount="5"] {height: 22.10%;}
.graph-cylinder [data-amount="6"] {height: 22.92%;}
.graph-cylinder [data-amount="7"] {height: 23.74%;}
.graph-cylinder [data-amount="8"] {height: 24.56%;}
.graph-cylinder [data-amount="9"] {height: 25.38%;}
.graph-cylinder [data-amount="10"] {height: 26.20%;}
.graph-cylinder [data-amount="11"] {height: 27.02%;}
.graph-cylinder [data-amount="12"] {height: 27.84%;}
.graph-cylinder [data-amount="13"] {height: 28.66%;}
.graph-cylinder [data-amount="14"] {height: 29.48%;}
.graph-cylinder [data-amount="15"] {height: 30.30%;}
.graph-cylinder [data-amount="16"] {height: 31.12%;}
.graph-cylinder [data-amount="17"] {height: 31.94%;}
.graph-cylinder [data-amount="18"] {height: 32.76%;}

.graph-cylinder [data-amount="19"] {height: 33.58%;}
.graph-cylinder [data-amount="20"] {height: 34.40%;}
.graph-cylinder [data-amount="21"] {height: 35.22%;}
.graph-cylinder [data-amount="22"] {height: 36.04%;}
.graph-cylinder [data-amount="23"] {height: 36.86%;}
.graph-cylinder [data-amount="24"] {height: 37.68%;}
.graph-cylinder [data-amount="25"] {height: 38.50%;}
.graph-cylinder [data-amount="26"] {height: 39.32%;}
.graph-cylinder [data-amount="27"] {height: 40.14%;}
.graph-cylinder [data-amount="28"] {height: 40.96%;}
.graph-cylinder [data-amount="29"] {height: 41.78%;}
.graph-cylinder [data-amount="30"] {height: 42.60%;}
.graph-cylinder [data-amount="31"] {height: 43.42%;}
.graph-cylinder [data-amount="32"] {height: 44.24%;}
.graph-cylinder [data-amount="33"] {height: 45.06%;}
.graph-cylinder [data-amount="34"] {height: 45.88%;}
.graph-cylinder [data-amount="35"] {height: 46.70%;}
.graph-cylinder [data-amount="36"] {height: 47.52%;}
.graph-cylinder [data-amount="37"] {height: 48.34%;}
.graph-cylinder [data-amount="38"] {height: 49.16%;}
.graph-cylinder [data-amount="39"] {height: 49.98%;}
.graph-cylinder [data-amount="40"] {height: 50.80%;}
.graph-cylinder [data-amount="41"] {height: 51.62%;}
.graph-cylinder [data-amount="42"] {height: 52.44%;}
.graph-cylinder [data-amount="43"] {height: 53.26%;}
.graph-cylinder [data-amount="44"] {height: 54.08%;}
.graph-cylinder [data-amount="45"] {height: 54.90%;}
.graph-cylinder [data-amount="46"] {height: 55.72%;}
.graph-cylinder [data-amount="47"] {height: 56.54%;}
.graph-cylinder [data-amount="48"] {height: 57.36%;}
.graph-cylinder [data-amount="49"] {height: 58.18%;}
.graph-cylinder [data-amount="50"] {height: 59.00%;}
.graph-cylinder [data-amount="51"] {height: 59.82%;}
.graph-cylinder [data-amount="52"] {height: 60.64%;}
.graph-cylinder [data-amount="53"] {height: 61.46%;}
.graph-cylinder [data-amount="54"] {height: 62.28%;}
.graph-cylinder [data-amount="55"] {height: 63.10%;}
.graph-cylinder [data-amount="56"] {height: 63.92%;}
.graph-cylinder [data-amount="57"] {height: 64.74%;}
.graph-cylinder [data-amount="58"] {height: 65.56%;}
.graph-cylinder [data-amount="59"] {height: 66.38%;}
.graph-cylinder [data-amount="60"] {height: 67.20%;}
.graph-cylinder [data-amount="61"] {height: 68.02%;}
.graph-cylinder [data-amount="62"] {height: 68.84%;}
.graph-cylinder [data-amount="63"] {height: 69.66%;}
.graph-cylinder [data-amount="64"] {height: 70.48%;}
.graph-cylinder [data-amount="65"] {height: 71.30%;}
.graph-cylinder [data-amount="66"] {height: 72.12%;}
.graph-cylinder [data-amount="67"] {height: 72.94%;}
.graph-cylinder [data-amount="68"] {height: 73.76%;}
.graph-cylinder [data-amount="69"] {height: 74.58%;}
.graph-cylinder [data-amount="70"] {height: 75.40%;}
.graph-cylinder [data-amount="71"] {height: 76.22%;}
.graph-cylinder [data-amount="72"] {height: 77.04%;}
.graph-cylinder [data-amount="73"] {height: 77.86%;}
.graph-cylinder [data-amount="74"] {height: 78.68%;}
.graph-cylinder [data-amount="75"] {height: 79.50%;}
.graph-cylinder [data-amount="76"] {height: 80.32%;}
.graph-cylinder [data-amount="77"] {height: 81.14%;}
.graph-cylinder [data-amount="78"] {height: 81.96%;}
.graph-cylinder [data-amount="79"] {height: 82.78%;}
.graph-cylinder [data-amount="80"] {height: 83.60%;}
.graph-cylinder [data-amount="81"] {height: 84.42%;}
.graph-cylinder [data-amount="82"] {height: 85.24%;}
.graph-cylinder [data-amount="83"] {height: 86.06%;}
.graph-cylinder [data-amount="84"] {height: 86.88%;}
.graph-cylinder [data-amount="85"] {height: 87.70%;}
.graph-cylinder [data-amount="86"] {height: 88.52%;}
.graph-cylinder [data-amount="87"] {height: 89.34%;}
.graph-cylinder [data-amount="88"] {height: 90.16%;}
.graph-cylinder [data-amount="89"] {height: 90.98%;}
.graph-cylinder [data-amount="90"] {height: 91.8%;}
.graph-cylinder [data-amount="91"] {height: 92.62%;}
.graph-cylinder [data-amount="92"] {height: 93.44%;}
.graph-cylinder [data-amount="93"] {height: 94.26%;}
.graph-cylinder [data-amount="94"] {height: 95%;}
.graph-cylinder [data-amount="95"] {height: 95.9%;}
.graph-cylinder [data-amount="96"] {height: 96.72%;}
.graph-cylinder [data-amount="97"] {height: 97.54%;}
.graph-cylinder [data-amount="98"] {height: 98.36%;}
.graph-cylinder [data-amount="99"] {height: 99.18%;}
.graph-cylinder [data-amount="100"] {height: 100%;}


</style>
